<template>
  <!-- Miniatura dibujada (no datos reales): muestra la forma del widget en el popup. -->
  <div class="wp" :class="`wp--${kind}`" aria-hidden="true">
    <template v-if="kind === 'calendar'">
      <div class="wp-cal-head"><span class="wp-line wp-w40"></span></div>
      <div class="wp-cal-grid">
        <span v-for="n in 28" :key="n" class="wp-cal-day">
          <i v-if="[3, 9, 10, 16, 22, 25].includes(n)" class="wp-chip" :class="{ 'wp-chip--alt': n % 2 }"></i>
        </span>
      </div>
    </template>

    <template v-else-if="kind === 'activity' || kind === 'list'">
      <div v-for="n in 5" :key="n" class="wp-row">
        <span class="wp-dot" :class="{ 'wp-dot--alt': kind === 'list' && n % 2 }"></span>
        <span class="wp-col">
          <span class="wp-line wp-strong" :style="{ width: `${80 - n * 9}%` }"></span>
          <span class="wp-line wp-w50"></span>
        </span>
      </div>
    </template>

    <template v-else-if="kind === 'alerts'">
      <div v-for="n in 4" :key="n" class="wp-row">
        <span class="wp-square wp-square--sm" :class="n === 1 ? 'wp-square--danger' : 'wp-square--warn'"></span>
        <span class="wp-col">
          <span class="wp-line wp-strong" :style="{ width: `${78 - n * 8}%` }"></span>
          <span class="wp-line wp-w50"></span>
        </span>
      </div>
    </template>

    <template v-else-if="kind === 'arrivals'">
      <div v-for="n in 4" :key="n" class="wp-row">
        <span class="wp-datebox"><span class="wp-line wp-strong"></span><span class="wp-line"></span></span>
        <span class="wp-col">
          <span class="wp-line wp-strong" :style="{ width: `${72 - n * 6}%` }"></span>
          <span class="wp-line wp-w70"></span>
        </span>
      </div>
    </template>

    <template v-else-if="kind === 'notifications'">
      <div v-for="n in 4" :key="n" class="wp-row">
        <span class="wp-dot" :class="{ 'wp-dot--alt': n > 2 }"></span>
        <span class="wp-col">
          <span class="wp-line wp-strong" :style="{ width: `${82 - n * 7}%` }"></span>
          <span class="wp-line wp-w90"></span>
        </span>
      </div>
    </template>

    <template v-else-if="kind === 'summary'">
      <div class="wp-tiles">
        <span v-for="n in 4" :key="n" class="wp-tile">
          <span class="wp-line wp-w50"></span>
          <span class="wp-num"></span>
        </span>
      </div>
    </template>

    <template v-else-if="kind === 'shortcuts'">
      <div class="wp-tiles wp-tiles--2">
        <span v-for="n in 2" :key="n" class="wp-tile wp-tile--row">
          <span class="wp-square"></span>
          <span class="wp-col">
            <span class="wp-line wp-strong wp-w70"></span>
            <span class="wp-line wp-w90"></span>
          </span>
        </span>
      </div>
    </template>

    <template v-else-if="kind === 'columns'">
      <div class="wp-columns">
        <span v-for="(h, n) in [35, 55, 42, 70, 62, 88, 50, 76, 66, 92, 58, 80]" :key="n" class="wp-colbar" :style="{ height: `${h}%` }"></span>
      </div>
    </template>

    <template v-else-if="kind === 'bars'">
      <div v-for="(w, n) in [92, 74, 58, 41, 27]" :key="n" class="wp-hbar">
        <span class="wp-line wp-w30"></span>
        <span class="wp-hbar__fill" :style="{ width: `${w * 0.6}%` }"></span>
      </div>
    </template>

    <template v-else-if="kind === 'kpi'">
      <span class="wp-line wp-w40"></span>
      <span class="wp-bignum"></span>
      <div class="wp-tiles wp-tiles--3">
        <span v-for="n in 3" :key="n" class="wp-tile"><span class="wp-num wp-num--sm"></span></span>
      </div>
    </template>

    <template v-else-if="kind === 'progress'">
      <span class="wp-line wp-w40"></span>
      <span class="wp-bignum"></span>
      <span class="wp-progress"><span class="wp-progress__fill"></span></span>
      <span class="wp-line wp-w70"></span>
    </template>

    <template v-else-if="kind === 'note'">
      <div class="wp-note">
        <span class="wp-line wp-w90"></span>
        <span class="wp-line wp-w70"></span>
        <span class="wp-line wp-w80"></span>
        <span class="wp-line wp-w40"></span>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "WidgetPreview",
  props: {
    kind: { type: String, default: "list" },
  },
};
</script>

<style scoped>
.wp {
  --wp-fg: var(--dw-line);
  --wp-fg-strong: var(--dw-line-strong);
  --wp-accent: var(--bs-primary);
  --wp-accent-soft: rgba(var(--bs-primary-rgb), 0.35);
  height: 100%;
  width: 100%;
  padding: 10px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  overflow: hidden;
  background: var(--dw-surface);
}
.wp-line {
  display: block;
  height: 5px;
  border-radius: 3px;
  background: var(--wp-fg);
}
.wp-strong { background: var(--wp-fg-strong); }
.wp-w30 { width: 30%; }
.wp-w40 { width: 40%; }
.wp-w50 { width: 50%; }
.wp-w70 { width: 70%; }
.wp-w80 { width: 80%; }
.wp-w90 { width: 90%; }
.wp-col { display: flex; flex-direction: column; gap: 4px; flex: 1; min-width: 0; }
.wp-row { display: flex; align-items: center; gap: 6px; }
.wp-dot { width: 9px; height: 9px; border-radius: 50%; background: var(--wp-accent); flex-shrink: 0; }
.wp-dot--alt { background: var(--wp-accent-soft); }

.wp-cal-grid { display: grid; grid-template-columns: repeat(7, 1fr); gap: 3px; flex: 1; }
.wp-cal-day {
  border: 1px solid var(--dw-border);
  border-radius: 3px;
  padding: 2px;
  display: flex;
  align-items: flex-end;
}
.wp-chip { display: block; width: 100%; height: 4px; border-radius: 2px; background: var(--wp-accent); }
.wp-chip--alt { background: var(--wp-accent-soft); }

.wp-tiles { display: grid; grid-template-columns: repeat(2, 1fr); gap: 6px; flex: 1; }
.wp-tiles--2 { grid-template-columns: repeat(2, 1fr); }
.wp-tiles--3 { grid-template-columns: repeat(3, 1fr); flex: 0 0 auto; }
.wp-tile {
  border: 1px solid var(--dw-border);
  border-radius: 4px;
  padding: 6px;
  display: flex;
  flex-direction: column;
  gap: 5px;
}
.wp-tile--row { flex-direction: row; align-items: center; }
.wp-square { width: 20px; height: 20px; border-radius: 4px; background: var(--wp-accent-soft); flex-shrink: 0; }
.wp-square--sm { width: 14px; height: 14px; }
.wp-square--warn { background: rgba(var(--bs-warning-rgb), 0.55); }
.wp-square--danger { background: rgba(var(--bs-danger-rgb), 0.55); }
.wp-datebox {
  width: 20px;
  height: 22px;
  border-radius: 4px;
  background: var(--dw-surface-2);
  border: 1px solid var(--dw-border);
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 3px;
  padding: 0 4px;
  flex-shrink: 0;
}
.wp-num { display: block; width: 45%; height: 10px; border-radius: 3px; background: var(--wp-accent); }
.wp-num--sm { height: 7px; width: 60%; }
.wp-bignum { display: block; width: 55%; height: 18px; border-radius: 4px; background: var(--wp-accent); }

.wp-columns { flex: 1; display: flex; align-items: flex-end; gap: 4px; border-bottom: 1px solid var(--dw-border); }
.wp-colbar { flex: 1; border-radius: 2px 2px 0 0; background: var(--wp-accent); opacity: 0.85; }

.wp-hbar { display: flex; align-items: center; gap: 6px; }
.wp-hbar .wp-line { flex-shrink: 0; }
.wp-hbar__fill { display: block; height: 9px; border-radius: 3px; background: var(--wp-accent); }

.wp-progress { display: block; height: 8px; border-radius: 4px; background: var(--wp-fg); overflow: hidden; }
.wp-progress__fill { display: block; height: 100%; width: 64%; background: var(--wp-accent); }

.wp-note {
  flex: 1;
  border-radius: 4px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 6px;
  background: var(--dw-note-bg);
  border: 1px solid var(--dw-note-border);
}
</style>
